// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__22lc8","amount":"Amount_amount__2YZAL","tip":"Amount_tip__x0IIt","tipHeader":"Amount_tipHeader__14bs-","tipsWrap":"Amount_tipsWrap__2YvNX"};